import React from "react";

const SubheadingField = ({ field }) => {
  const { title, headingLevel = "h3", subheadingDescription = "" } = field;

  // Define styling for different heading levels
  const getHeadingStyles = (level) => {
    switch (level) {
      case "h2":
        return "text-2xl font-bold text-gray-800 border-b-2 border-gray-200 pb-2";
      case "h3":
        return "text-xl font-semibold text-gray-700 border-b border-gray-100 pb-1";
      case "h4":
        return "text-lg font-medium text-gray-600";
      default:
        return "text-xl font-semibold text-gray-700 border-b border-gray-100 pb-1";
    }
  };

  const HeadingComponent = ({ level, className, children }) => {
    const Tag = level;
    return <Tag className={className}>{children}</Tag>;
  };

  return (
    <div className="mb-6 mt-8">
      <HeadingComponent
        level={headingLevel}
        className={getHeadingStyles(headingLevel)}
      >
        {title}
      </HeadingComponent>
      {subheadingDescription && (
        <p className="text-sm text-gray-500 mt-2 mb-4">
          {subheadingDescription}
        </p>
      )}
    </div>
  );
};

export default SubheadingField;